export default __webpack_public_path__ + "static/media/blogn-full.64b62f73.svg";